import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditingSection } from '@app/features/questionnaire/components/questions/style-tab/section-editors/editing-section';
import { Questionnaire } from '@app/core/models/questionnaire.model';
import { buildRuntimePreviewContext } from '@app/features/questionnaire/components/questions/style-tab/preview/runtime-context.builder';
import { getFooterPreviewData } from '@app/features/questionnaire/components/questions/style-tab/preview/preview-style.resolver';

@Component({
  selector: 'app-survey-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './survey-footer.html',
  styleUrl: './survey-footer.scss',
})
export class SurveyFooter {
  @Input() questionnaire: Questionnaire | null = null;

  get data() {
    if (!this.questionnaire) return null;
    const context = buildRuntimePreviewContext(
      this.questionnaire,
      EditingSection.FOOTER
    );
    return getFooterPreviewData(context);
  }
}
